import React from 'react';
import { FormControl } from 'react-bootstrap';
import { Typography } from 'Components/atoms';
import { CustomActionDto } from '@ampsec/platform-client';
import { ACTION_LABELS, SUPPORTING_TEXT } from 'Core-utils/constants/constants';
import { MICROSOFT_INTUNE_REBOOT_DESCRIPTION, MICROSOFT_INTUNE_REBOOT_TITLE } from './microsoftIntuneTemplates';

interface MicrosoftIntuneGeneralStepProps {
    formData: CustomActionDto;
    handleFieldChange: (id: string, value: string) => void;
    errors: string[];
}

const renderError = (error: string) => (
    <Typography variant="caption4" color="vizualization-red-200">
        {error} {SUPPORTING_TEXT}
    </Typography>
);

export const MicrosoftIntuneGeneralStep: React.FC<MicrosoftIntuneGeneralStepProps> = ({
    formData,
    handleFieldChange,
    errors,
}) => {
    return (
        <div className="action-block d-flex flex-column gap-3">
            <div className="d-flex flex-column gap-1">
                <Typography variant="subtitle2" color="text-high-emphasis">
                    {MICROSOFT_INTUNE_REBOOT_TITLE}
                </Typography>
                <Typography variant="body3" color="text-medium-emphasis">
                    {MICROSOFT_INTUNE_REBOOT_DESCRIPTION}
                </Typography>
            </div>

            <div className="d-flex flex-column gap-2">
                <Typography variant="body3" color="text-medium-emphasis">
                    {ACTION_LABELS[2]}
                </Typography>
                <FormControl
                    value={formData.displayValue ?? ''}
                    className="input-field__input bg-transparent"
                    onChange={(event) => handleFieldChange('displayValue', event.target.value)}
                    placeholder="e.g. Reboot device via Intune"
                    maxLength={50}
                />
                <Typography variant="caption1" color="text-low-emphasis">
                    This name appears when you attach the action to an engagement flow.
                </Typography>
                {errors.includes(`${ACTION_LABELS[2]} ${SUPPORTING_TEXT}`) && renderError(`${ACTION_LABELS[2]}`)}
            </div>

            <div className="d-flex flex-column gap-2">
                <Typography variant="body3" color="text-medium-emphasis">
                    {ACTION_LABELS[5]}
                </Typography>
                <FormControl
                    as="textarea"
                    rows={3}
                    value={formData.description ?? ''}
                    className="input-field__input bg-transparent"
                    onChange={(event) => handleFieldChange('description', event.target.value)}
                    placeholder="Optional notes for admins configuring this action."
                    maxLength={200}
                />
            </div>
        </div>
    );
};
